(function(){
  if (typeof window === "undefined") return;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function reveal(){
    var els = document.querySelectorAll(".al-reveal");
    if (!("IntersectionObserver" in window) || reduce) { els.forEach(function(el){ el.classList.add("is-visible"); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          var d = parseInt(e.target.getAttribute("data-delay") || "0", 10);
          setTimeout(function(){ e.target.classList.add("is-visible"); }, d);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -60px 0px" });
    els.forEach(function(el){ io.observe(el); });
  }
  function parallax(){
    if (reduce) return;
    var nodes = Array.prototype.slice.call(document.querySelectorAll("[data-al-parallax]"));
    if (!nodes.length) return;
    var ticking = false;
    function update(){
      var vh = window.innerHeight;
      nodes.forEach(function(n){
        var r = n.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(n.getAttribute("data-speed") || "0.15");
        var center = r.top + r.height/2 - vh/2;
        var y = -center * speed;
        n.style.transform = n.classList.contains("al-philosophy__watermark")
          ? "translate(-50%, calc(-50% + " + y.toFixed(1) + "px))"
          : "translate3d(0," + y.toFixed(1) + "px,0)";
      });
      ticking = false;
    }
    function onScroll(){ if (!ticking) { window.requestAnimationFrame(update); ticking = true; } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }
  function init(){ reveal(); parallax(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();